import { jsx as e } from "react/jsx-runtime";
//#region lib/Factbox/components/FactboxTitle.tsx
var t = ({ children: t }) => /* @__PURE__ */ e("div", {
	className: "pt-2 font-sans text-2xl font-bold text-slate-700 dark:text-slate-300",
	children: t
});
//#endregion
export { t as FactboxTitle };
